/* eslint-disable import/prefer-default-export */
import Login from './login'
// import SignUp from './SignUp'

export {
  Login
  // SignUp
}
